import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";

const CROWD =
  "https://images.pexels.com/photos/11329863/pexels-photo-11329863.jpeg";

export const Credibility = () => {
  const { t } = useLanguage();
  const c = t.credibility;

  return (
    <section id="credibility" className="relative py-24 md:py-32 overflow-hidden bg-[#7E1A2E]">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 mix-blend-overlay"
        style={{ backgroundImage: `url(${CROWD})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#7E1A2E] via-[#6A1526] to-[#4A0F1B]" />
      <div className="container-page relative">
        <div className="max-w-4xl">
          <Reveal>
            <span className="overline text-white/70">{c.overline}</span>
            <h2 className="mt-5 font-display font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
              {c.title}
            </h2>
            <p className="mt-7 text-lg md:text-xl text-white/85 leading-relaxed">{c.text}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/15 border border-white/15">
          {c.stats.map((s, i) => (
            <Reveal key={i} delay={0.08 * i} className="bg-[#7E1A2E]">
              <div className="p-8 text-center" data-testid={`credibility-stat-${i}`}>
                <div className="font-display font-black text-white text-2xl md:text-3xl tracking-tight leading-tight">{s.value}</div>
                <div className="mt-3 text-sm text-white/70 uppercase tracking-[0.15em]">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
